import { ColumnSort } from "@tanstack/react-table";
import { DefaultQueryBuilder } from "@/core/api/DefaultQueryBuilder";
import { QueryParamEntry } from "@/core/api/QueryBuilder";
import {
  Filter,
  FilterOperator,
  Filters,
  isReadOnlyFilterType,
  processFilterValue,
} from "./filters";

const hasFilterOperators = (value: string): boolean => {
  const operators = [FilterOperator.AND, FilterOperator.OR];
  return operators.some((operator) => value.includes(operator));
};

const appendExportFilterEntries = (
  entries: QueryParamEntry[],
  id: string,
  { filter, value }: Filter,
) => {
  const filterKey = filter ? `${id}[${filter}]` : id;
  const hasNoValue = value === undefined || value === "";

  if (isReadOnlyFilterType(filter)) {
    entries.push([filterKey, ""]);
    return;
  }

  if (hasNoValue) {
    return;
  }

  const stringValue = String(value);

  if (hasFilterOperators(stringValue)) {
    Array.from(new Set(processFilterValue(stringValue))).forEach((val) => {
      entries.push([filterKey, val.trim()]);
    });
    return;
  }

  entries.push([filterKey, stringValue.trim()]);
};

export const buildExportQueryParamEntries = <T>(
  filters?: Filters<T>,
  sorting?: ColumnSort,
): QueryParamEntry[] => {
  const entries: QueryParamEntry[] = [];

  if (sorting?.id) {
    entries.push(["sort", sorting.desc ? `-${sorting.id}` : sorting.id]);
  }

  filters?.forEach(({ id, value }) =>
    appendExportFilterEntries(entries, id, value),
  );

  return entries;
};

export const buildExportQueryParams = <T>(
  filters?: Filters<T>,
  sorting?: ColumnSort,
): URLSearchParams => {
  return DefaultQueryBuilder.toSearchParams(
    buildExportQueryParamEntries(filters, sorting),
  );
};
